import { render, staticRenderFns } from "./purchasedPacketModal.vue?vue&type=template&id=e486bca6&scoped=true&"
import script from "./purchasedPacketModal.vue?vue&type=script&lang=js&"
export * from "./purchasedPacketModal.vue?vue&type=script&lang=js&"
import style0 from "./purchasedPacketModal.vue?vue&type=style&index=0&id=e486bca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e486bca6",
  null
  
)

export default component.exports